import type { ApiErrorBody, BootstrapData, SearchBook } from '../types';

async function parse<T>(response: Response): Promise<T> {
	const body = (await response.json().catch(() => ({}))) as T | ApiErrorBody;
	if (!response.ok) {
		throw new Error('error' in (body as ApiErrorBody) ? (body as ApiErrorBody).error : 'Please try again.');
	}
	return body as T;
}

export async function getSession(): Promise<boolean> {
	const response = await fetch('/api/session', { credentials: 'same-origin' });
	const body = await parse<{ authenticated: boolean }>(response);
	return body.authenticated;
}

export async function login(password: string): Promise<void> {
	await request('/api/auth/login', { password });
}

export async function logout(): Promise<void> {
	await request('/api/auth/logout', {});
}

export async function getBootstrap(memberId: string): Promise<BootstrapData> {
	const response = await fetch(`/api/bootstrap?member=${encodeURIComponent(memberId)}`, {
		credentials: 'same-origin',
	});
	return parse<BootstrapData>(response);
}

export interface BookSearchResult {
	books: SearchBook[];
	catalogueStatus: 'live' | 'cached' | 'stale';
}

export async function searchBooks(query: string): Promise<BookSearchResult> {
	const response = await fetch(`/api/books/search?q=${encodeURIComponent(query)}`, {
		credentials: 'same-origin',
	});
	return parse<BookSearchResult>(response);
}

export async function request<T = { ok: boolean }>(path: string, body: Record<string, unknown>, method = 'POST'): Promise<T> {
	const response = await fetch(path, {
		method,
		credentials: 'same-origin',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(body),
	});
	return parse<T>(response);
}
